// extracted by mini-css-extract-plugin
export var footer = "_nk-0";
export var inherit = "_nk-1";
export var input = "_nk-2";
export var modalContent = "_nk-3";
export var quillEditor = "_nk-4";
export var subtitle = "_nk-5";